import { render } from "./view-claimtype.vue?vue&type=template&id=7eb5750e&lang=html"
import script from "./view-claimtype.vue?vue&type=script&lang=js"
export * from "./view-claimtype.vue?vue&type=script&lang=js"

import "./view-claimtype.vue?vue&type=style&index=0&id=7eb5750e&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__